import React from 'react';
import { RootElement } from './src/components/_common/root-element';
import { AccountContextProvider } from './src/context/account/account.context';
import { LoadingAnimationContextProvider } from './src/context/loading-animation/loading-animation.context';
import OrderContextProvider from './src/context/order/order.context';
import { appInsights } from './src/lib/ApplicationInsights';

export const onClientEntry = () => {
  if (process.env.GATSBY_APP_INSIGHTS_INSTRUMENTATION_KEY && process.env.GATSBY_APP_INSIGHTS_INSTRUMENTATION_KEY !== '') {
    appInsights.loadAppInsights();
    appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview
    console.info(`Application Insights connected!`);
  } else {
    console.error('Application Insights not configured correctly!');
  }

  const SESSION_STORAGE_REFERRER = 'referrer';
  if (document.referrer && !sessionStorage.getItem(SESSION_STORAGE_REFERRER)) {
    sessionStorage.setItem(SESSION_STORAGE_REFERRER, document.referrer);
  }
};

export const wrapRootElement = ({ element }) => (
  <RootElement>
    <LoadingAnimationContextProvider>
      <OrderContextProvider>
        <AccountContextProvider>{element}</AccountContextProvider>
      </OrderContextProvider>
    </LoadingAnimationContextProvider>
  </RootElement>
);
